var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"mb-4 no-underline title-font md:mb-0 hover:no-underline",attrs:{"to":"/"}},[_c('span',{staticClass:"text-4xl font-bold text-purple-500 font-headline"},[_c('img',{attrs:{"src":require("@/assets/img/logo_bg.png"),"width":"120px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }